import { BasicLayout, BlankLayout } from '@/layout'

const financialRouter = {
  path: '/financial',
  name: 'Finance',
  alwaysShow: true,
  component: BasicLayout,
  redirect: 'noRedirect',
  meta: { title: '财务管理', icon: 'money' },
  children: [
    {
      path: 'company',
      name: 'FinanceCompany',
      meta: { title: '公司资金' },
      component: () => import('@/views/financial/company')
    },
    {
      path: 'member',
      name: 'FinanceMember',
      meta: { title: '用户提现' },
      component: () => import('@/views/financial/index')
    },
    {
      path: 'supplier',
      name: 'FinanceSupplier',
      meta: { title: '供应商结算' },
      component: () => import('@/views/financial/supplier')
    },
    {
      path: 'report',
      component: BlankLayout, // Parent router-view
      name: 'FinanceReports',
      meta: { title: '财务报表', icon: 'table' },
      redirect: '/financial/report/transaction',
      children: [
        {
          path: 'transaction',
          name: 'FinanceTransaction',
          meta: { title: '交易流水' },
          component: () => import('@/views/financial/report/transaction')
        },
        {
          path: 'revenue',
          name: 'FinanceRevenue',
          meta: { title: '收入明细' },
          component: () => import('@/views/financial/report/revenue')
        },
        {
          path: 'expense',
          name: 'FinanceExpense',
          meta: { title: '支出明细' },
          component: () => import('@/views/financial/report/expense')
        }
      ]
    }
  ]
}

export default financialRouter
